import { ChangeDetectionStrategy, Component, ComponentRef, HostBinding } from '@angular/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('toastIn', [
      state('open', style({ transform: 'translateY(0)' })),
      transition('void => open', [
        style({
          transform: 'translateY(100%)',
        }),
        animate('100ms ease-in'),
      ]),
      transition('open => void', [
        animate(
          '100ms ease-out',
          style({
            transform: 'translateY(100%)',
          }),
        ),
      ]),
    ]),
  ],
})
export class ToastComponent {
  title!: string;
  componentRef!: ComponentRef<ToastComponent>;

  closeIcon = faTimes;

  @HostBinding('@toastIn') get toastIn() {
    return 'open';
  }

  close() {
    this.componentRef.destroy();
  }
}
